export const prod = {
  orchestratorServer: {
    baseUri: 'https://cx-api.prospa.com',
  },
};
